import React from 'react';

import { useIntl } from 'react-intl';

import { convertVideoDuration } from '../../../search-page-relay/search-results/search-result/search-result-renderer/search-graph-result/search-graph-video/convert-video-duration';

export const LoomVideoDuration = ({
	durationInSeconds,
}: {
	durationInSeconds: number;
}): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const duration = convertVideoDuration(durationInSeconds, {
		readable: true,
		formatMessage,
	});

	return duration ? <>{duration}</> : null;
};
